export enum HgLocalStorageKey {
  FAVOURITE_LISTINGS = 'favouriteListings',
  FAVOURITES_ONBOARDING_MESSAGE_CLOSED = 'isFavouritesOnboardingMessageClosed',
  TENANT_PLUS_SUPSCRIPTION_CACHE = 'tenantPlusSubscriptionCache',
}
